import { Link } from 'react-router-dom'

import { styled } from 'styled-system/jsx'

const SectionRoot = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
})

const SectionHeader = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'space-between',
    paddingX: '4px',
  },
})

const SectionTitle = styled('h2', {
  base: {
    fontFamily: 'display',
    fontSize: '22px',
    fontWeight: '700',
    color: 'quickpass.ink',
    margin: '0',
    letterSpacing: '-0.5px',
  },
})

const SectionLink = styled(Link, {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    fontWeight: '600',
    color: 'quickpass.primary',
    textDecoration: 'none',
    cursor: 'pointer',
    _hover: {
      textDecoration: 'underline',
      textUnderlineOffset: '3px',
    },
  },
})

const ScrollRail = styled('div', {
  base: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))',
    gap: '12px',
  },
})

const SkeletonRow = styled('div', {
  base: {
    height: '300px',
    backgroundColor: '#FFFFFF',
    borderRadius: 'lg',
    border: '1.5px solid #F1ECFF',
    opacity: '0.55',
  },
})

export {
  SectionRoot,
  SectionHeader,
  SectionTitle,
  SectionLink,
  ScrollRail,
  SkeletonRow,
}
